import { ApiServiceBase } from '../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Observable } from 'rxjs';
import { StateReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
  providedIn: 'root'
})
export class StateReferenceService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/system/StateReferences"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getAll(): Observable<StateReferenceModel[]> {
    return this.httpGet<StateReferenceModel[]>(this.REFERENCE_PATH, null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }
}